import React, {isValidElement} from "react"
import Icon from "../../components/Icon/Icon"
import {IcomoonIconName} from "../../components/Icon/icons"

interface Props {
	icon?: IcomoonIconName | JSX.Element
}

export type CardIconProps = Props

export default function CardIcon({icon}: CardIconProps) {
	if (typeof icon === "string") {
		return <Icon icon={icon} size={20} />
	} else if (isValidElement(icon)) {
		return icon
	}
	return null
}
